var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"font-weight-light body-1 grey--text"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"title font-weight-regular black--text"},[_vm._v(_vm._s(_vm.titleName))])])}
var staticRenderFns = []

export { render, staticRenderFns }